/**
 * Types for POST /predict/tools endpoint.
 * Mirrors backend models from ga_kasko_model_3d and ga_kasko_eda_be.apt_generation.
 * Field names kept in snake_case for API compatibility.
 */

export type HoleBottom = 'DRILL_TIP' | 'FLAT' | 'THROUGH_HOLE';

export type DrillSide = '+X' | '-X' | '+Y' | '-Y' | '+Z' | '-Z';

export const HOLE_BOTTOM_VALUES: HoleBottom[] = ['DRILL_TIP', 'FLAT', 'THROUGH_HOLE'];
export const DRILL_SIDE_VALUES: DrillSide[] = ['+X', '-X', '+Y', '-Y', '+Z', '-Z'];

export interface PlusMinusTol {
  pm: number;
}

export interface MinMaxTol {
  min: number;
  max: number;
}

export interface HoleTolerance {
  diameter?: PlusMinusTol | null;
  position_xy?: PlusMinusTol | null;
  depth?: PlusMinusTol | null;
}

export interface HoleWCS {
  x_mm: number;
  y_mm: number;
  diameter_mm: number;
  depth_mm: number;
  z_entry_mm: number;
  bottom: HoleBottom;
  color_wall?: string | null;
  color_bottom?: string | null;
  color_chamfer?: string | null;
  chamfer_angle_deg?: number | null;
  chamfer_diameter_mm?: number | null;
  chamfer_depth_mm?: number | null;
  drill_point_angle_deg?: number | null;
  thread_pitch_mm?: number | null;
  tol?: HoleTolerance | null;
}

export interface HoleRequest {
  hole: HoleWCS;
  drill_side: DrillSide;
  thickness: number;
}

/** Response item from POST /predict/tools – mirrors ToolChangeInfo from backend. */
export interface ToolChangeInfo {
  assembly_id: string;
  assembly_comment: string;
  assembly_power: string;
  assembly_tl_set_len: number;
  tool_name: string;
  tool_type: string;
  tool_comment: string;
  tool_number: number;
  tool_diameter: number;
  tool_corner_rad: number | null;
  tool_cut_angle: number | null;
  tool_overall_len: number;
  tool_cut_len: number | null;
  tool_len: number;
  tool_rotation: string;
  tl_axis: [number, number, number];
  horizontal_distance: number | null;
  vertical_distance: number | null;
  tip_angle: number | null;
  flank_angle: number | null;
  support_finish: boolean;
  pitch: number | null;
  tool_pitch: number | null;
  length_1: number | null;
  thread_diameter: number | null;
  diameter: number | null;
  spindle: number | null;
  feed_mach_value: number | null;
}
